import { useContext } from 'react'
import RightsForOrgContext from './RightsForOrgContext'


const useRightsForOrgData = () => useContext(RightsForOrgContext)
export default useRightsForOrgData
